import { memo } from 'react';
import { Title, Wrapper, CheckboxGroup, SecondaryList } from '../../design-system';
import { OtherRequirementsPreview } from './other-requirements-preview';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SkillsPreviewBlock = /*#__PURE__*/memo(function (_ref) {
  var _ref$requiredSkills = _ref.requiredSkills,
      requiredSkills = _ref$requiredSkills === void 0 ? [] : _ref$requiredSkills,
      _ref$optionalSkills = _ref.optionalSkills,
      optionalSkills = _ref$optionalSkills === void 0 ? [] : _ref$optionalSkills,
      _ref$otherRequirement = _ref.otherRequirements,
      otherRequirements = _ref$otherRequirement === void 0 ? [] : _ref$otherRequirement,
      _ref$education = _ref.education,
      education = _ref$education === void 0 ? [] : _ref$education,
      _ref$certificates = _ref.certificates,
      certificates = _ref$certificates === void 0 ? [] : _ref$certificates,
      _ref$languages = _ref.languages,
      languages = _ref$languages === void 0 ? [] : _ref$languages;
  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [/*#__PURE__*/_jsx(Title, {
      content: "Requisiti e competenze",
      icon: "ClipboardDocumentListIcon",
      variant: "h4-large",
      fontWeight: "semibold",
      textColor: "black"
    }), (requiredSkills === null || requiredSkills === void 0 ? void 0 : requiredSkills.length) > 0 && /*#__PURE__*/_jsx(CheckboxGroup, {
      options: requiredSkills,
      value: [],
      isWrapList: true
    }), (optionalSkills === null || optionalSkills === void 0 ? void 0 : optionalSkills.length) > 0 && /*#__PURE__*/_jsx(SecondaryList, {
      itemList: optionalSkills.map(function (v) {
        return {
          key: v,
          label: v,
          icon: 'ClipboardDocumentCheckIcon'
        };
      }),
      orientation: "vertical",
      textColor: "gray",
      isWrapList: true,
      fontSize: "base"
    }), /*#__PURE__*/_jsx(OtherRequirementsPreview, {
      otherRequirements: otherRequirements,
      education: education,
      certificates: certificates,
      languages: languages
    })]
  });
});
SkillsPreviewBlock.displayName = 'SkillsPreviewBlock';